import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { motion } from '@utils/framerMotionProxy';
import { useAuth } from '../../contexts/AuthContext';
import LanguageSwitcher from './LanguageSwitcher';
import MobileMenu from './MobileMenu';

const Header = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const { user, isAuthenticated, logout } = useAuth();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const headerNavTextClass = 'text-white hover:text-gray-200 transition-colors font-bold text-sm lg:text-xs';
  const accountButtonClass = `flex items-center gap-2 px-1 py-2 bg-transparent hover:bg-transparent rounded-none ${headerNavTextClass}`;

  console.log('Header - user:', user);
  console.log('Header - user role:', user?.role);
  console.log('Header - isAuthenticated:', isAuthenticated);

  // Отслеживание скролла для изменения стиля header
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Навигационные элементы
  const navigationItems = [
    { key: 'home', href: '/', label: t('nav.home').toUpperCase() },
    { key: 'about', href: '/about', label: t('nav.about').toUpperCase() },
    { key: 'education', href: '/education', label: t('nav.education').toUpperCase() },
    { key: 'articles', href: '/articles', label: t('nav.articles').toUpperCase() },
    { key: 'training', href: '/training', label: t('nav.training').toUpperCase() },
    { key: 'shop', href: '/shop', label: t('nav.shop').toUpperCase() },
  ];
  const handleAnchorClick = (href) => {
    if (href.startsWith('/#')) {
      const elementId = href.substring(2);
      if (location.pathname === '/') {
        // Уже на главной странице, просто прокручиваем
        const element = document.getElementById(elementId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      } else {
        // Переходим на главную страницу с якорем
        navigate('/');
        setTimeout(() => {
          const element = document.getElementById(elementId);
          if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
          }
        }, 100);
      }
    } else {
      navigate(href);
    }
  };

  const handleAdminLogout = async () => {
    await logout();
    navigate('/');
  };

  return (
    <motion.header
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
      className="fixed top-0 left-0 right-0 z-50 rounded-b-2xl"
      style={{
        backgroundColor: '#EC8C8E'
      }}
    >
      <div className="container-custom lg:px-2">
        <div className="relative flex items-center h-16 md:h-20">
          {/* Логотип для мобильной версии */}
          <Link
            to="/"
            className="flex items-center group lg:hidden"
          >
            <img
              src="/images/logo/logo.svg"
              alt="Elena Fiore Couture"
              className="h-12 md:h-16 w-auto group-hover:scale-105 transition-transform duration-300"
            />
          </Link>

          {/* Навигация для десктопа (слева) */}
          <nav className="hidden lg:flex flex-1 items-center gap-5 pr-24">
            {navigationItems.map((item) => (
              <button
                key={item.key}
                onClick={() => handleAnchorClick(item.href)}
                className={headerNavTextClass}
              >
                {item.label}
              </button>
            ))}
          </nav>

          {/* Логотип для десктопа (по центру экрана) */}
          <Link
            to="/"
            className="hidden lg:flex items-center group absolute left-1/2 -translate-x-1/2"
          >
            <img
              src="/images/logo/logo.svg"
              alt="Elena Fiore Couture"
              className="h-14 w-auto group-hover:scale-105 transition-transform duration-300"
            />
          </Link>

          {/* Правая часть header */}
          <div className="ml-auto flex items-center gap-2 sm:gap-3 lg:flex-1 lg:justify-end lg:gap-3 lg:pl-24">
            {/* Переключатель языка */}
            <LanguageSwitcher />

            {/* Авторизация */}
            {isAuthenticated ? (
              <>
                <Link
                  to={user?.role === 'admin' ? '/admin' : '/account'}
                  state={user?.role === 'admin' ? undefined : { backgroundLocation: location }}
                  className={`hidden md:flex ${accountButtonClass}`}
                >
                  {user?.role === 'admin' ? t('nav.admin').toUpperCase() : t('nav.account').toUpperCase()}
                </Link>
                {user?.role === 'admin' && (
                  <button
                    type="button"
                    onClick={handleAdminLogout}
                    className={`hidden md:flex ${accountButtonClass}`}
                  >
                    {t('nav.logout').toUpperCase()}
                  </button>
                )}
              </>
            ) : (
              <Link
                to="/auth"
                state={{ backgroundLocation: location }}
                className={`hidden md:flex ${accountButtonClass}`}
              >
                {t('nav.account').toUpperCase()}
              </Link>
            )}

            {/* Мобильное меню */}
            <button
              onClick={() => setIsMobileMenuOpen(true)}
              className="lg:hidden inline-flex items-center justify-center px-1 py-2 text-white hover:text-gray-200 transition-colors"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
          </div>
        </div>
      </div>

      {/* Мобильное меню */}
      <MobileMenu
        isOpen={isMobileMenuOpen}
        onClose={() => setIsMobileMenuOpen(false)}
        navigationItems={navigationItems}
        onNavigate={handleAnchorClick}
      />
    </motion.header>
  );
};

export default Header;
